import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {liveDashboard_template} from "../components/templates/liveDashboard_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class liveDashboard extends vnModule_knockoutJS{

    protected liveDashboard_template: liveDashboard_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected urlPath: string;
    protected zoneHeader: vnAppZone | null;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'liveDashboard';
    }


    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Live Dashboard');

        this.liveDashboard_template = new liveDashboard_template('liveDashboard', this.viewModel, this)
        this.template = this.liveDashboard_template;

        this.urlPath = window.location.origin + window.location.pathname;
        this.setAutoRefresh();

        return [this.liveDashboard_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        this.liveDashboard_template.setDevice(this.getVnAppZone().getCookie('device'));
        this.liveDashboard_template.setDeviceView(this.getVnAppZone().getCookie('deviceView'));

        this.liveDashboard_template.buildDatePickerCalendar();
        this.liveDashboard_template.setComparisonFilterItems();
        this.liveDashboard_template.setMetricFilterItems();
        this.liveDashboard_template.setIntervalFilterItems();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void {

        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#report-results"));

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler('/api/live_dashboard/references/', usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected paginationOnPageClick(){

        this.getTableData();
    }

        /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#report-results"));

                // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                obj.zoneHeader?.loadedModule.showPlanPromo();

                let responseParsed = JSON.parse(req.request.response);

                obj.liveDashboard_template.getTemplateViewModel().clientTimezone(responseParsed.clientTimezone.value);

                obj.updateFilters(responseParsed);

                obj.updateViewModelFromPath();

                obj.setBotMode();

                obj.getReportStatus();

                obj.getSampledDates();

                obj.getTotalsData();

                obj.getReportWidgetsData();

                obj.getIndicatorsByDateData();

                obj.getTableData();

                
            });
        }
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void {

        this.liveDashboard_template.setReportWidgetColumnLayout(responseParsed.reportWidgetColumnLayout);
        this.liveDashboard_template.setSegmentsFilterException(responseParsed.segmentsFilterException);
        this.liveDashboard_template.setSystemsFilterException(responseParsed.systemsFilterException);
        this.liveDashboard_template.setUsColumnException(responseParsed.usColumnException);
        this.liveDashboard_template.setBotToggleButtonException(responseParsed.botToggleButtonException);
        this.liveDashboard_template.setDeltaToggleButtonException(responseParsed.deltaToggleButtonException);
        this.liveDashboard_template.setCpmColumnVisible(responseParsed.cpmColumnVisible);
        this.liveDashboard_template.setDynamicFilters(responseParsed.dynamicFiltersData);
        this.liveDashboard_template.setBrandFilterItems(responseParsed.portfolios);
        this.liveDashboard_template.setViewModeFilterItems(responseParsed.viewModes);
        this.liveDashboard_template.setSegmentsFilterItems(responseParsed.segments);
        this.liveDashboard_template.setDefaultDevices();
    }

    public getReportWidgetsData(): void {

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/live_dashboard/widgetTotals/get/';
        let reportWidgetColumnLayout = this.liveDashboard_template.getTemplateViewModel().reportWidgetColumnLayout();

        reportWidgetColumnLayout.forEach((column) => {

            column.forEach((position) => {

                if (position.widgetName && position.widgetType) {

                    if(position.widgetType == 'internalDimension' || position.widgetType == 'customDimension'){

                        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#widgetLoading_" + position.filterId), true);

                        subViewModel['widgetName'] = position.widgetName;
                        subViewModel['widgetType'] = position.widgetType;

                        this.sendFilterCall(baseApiUrl, subViewModel, this.onWidgetDimensionDataRequestReturn.bind(this, position.widgetName, position.filterId), XMLHttpRequestHandler_requestType.GET, 'getWidgetDimensionData_' + position.widgetName + '_' + position.widgetType);
                    }
                    else if(position.widgetType == 'graph' && position.widgetName == 'Ping Graph'){

                        this.getPingDiffIndicators();
                    }
                    else if(position.widgetType == 'graph' && position.widgetName == 'Ping Load Time'){

                        this.getPingLoadTimeIndicators();
                    }
                }
            });

        });
    }

    public getReportStatus(): void {

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/live_dashboard/reportStatus/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onReportStatusRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getReportStatus');
    }

    public getSampledDates(): void{

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/live_dashboard/sampledDates/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onSampledDatesRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getSampledDates');
    }

    public getTotalsData(): void {

        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#totals-widget"), true);

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/live_dashboard/totals/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onTotalsDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getTotalsData');
    }

    public getTableData(resetPagination: boolean = false): void{

        if (resetPagination) {

            this.liveDashboard_template.getTemplateViewModel().pagination.pageNumber(1);
        }

        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#topArticles-results"), true);

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/live_dashboard/topArticles/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onTableDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getTableData');
    }

    public getPingDiffIndicators(): void {

        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#widgetLoading_pingGraph-graph"), true);

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        subViewModel['filters']['deviceView'] = this.getVnAppZone().getCookie('deviceView');
        subViewModel['filters']['device'] = this.getVnAppZone().getCookie('device');
        let baseApiUrl = '/api/live_dashboard/pingDiffIndicators/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetPingDiffIndicators, XMLHttpRequestHandler_requestType.GET, 'getPingDiffIndicators');
    }

    public getPingLoadTimeIndicators(): void {

        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#widgetLoading_pingLoadTime-graph"), true);

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        subViewModel['filters']['deviceView'] = this.getVnAppZone().getCookie('deviceView');
        subViewModel['filters']['device'] = this.getVnAppZone().getCookie('device');
        let baseApiUrl = '/api/live_dashboard/pingLoadTimeIndicators/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetPingLoadTimeIndicators, XMLHttpRequestHandler_requestType.GET, 'getPingLoadTimeIndicators');
    }


    public getIndicatorsByDateData(): void {

        this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);

        this.liveDashboard_template.clearTimelineAnnotatonData();

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        subViewModel['filters']['deviceView'] = this.getVnAppZone().getCookie('deviceView');
        subViewModel['filters']['device'] = this.getVnAppZone().getCookie('device');
        let baseApiUrl = '/api/live_dashboard/indicatorsByTimeIntervals/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onIndicatorsByDateDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getIndicatorsByDateData');
    }

    public getSegmentsByDateData(): void {

        /* this.loadingIn(this.liveDashboard_template.builtTemplate.querySelector("#segmentsByDate-results"));

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/liveDashboard/segmentsByDate/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onSegmentsByDateDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getSegmentsByDateData'); */
    }

    protected onWidgetDimensionDataRequestReturn(widgetName, filterId, req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                    let responseParsed = JSON.parse(req.request.response);

                    obj.liveDashboard_template.setReportWidgetData(responseParsed, widgetName);

                    if(req.request.status != 0) {

                        obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#widgetLoading_" + filterId), true);
                    }
            });
        }
    }

        /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onReportStatusRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateReportStatusData(responseParsed);
                }
            }
        }
    }

    protected onSampledDatesRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateSampledDatesData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                }
            }
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onTotalsDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateTotalsData(responseParsed);

                if(req.request.status != 0) {

                    obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#totals-widget"), true);
                }
            });
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onTableDataRequestReturn(req, obj): Function{

        return function() {

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                const offset = (responseParsed.currentPage - 1) * obj.liveDashboard_template.pagination.getTemplateViewModel().itemPerPage;

                obj.updatePagination(responseParsed.totalCount);
                obj.liveDashboard_template.setPageOffset(offset);

                if (obj.liveDashboard_template.getTemplateViewModel().dimensionGroupSwitch() == 'time') {

                    obj.updateTopArticlesData(responseParsed);
                } else  {

                    obj.updateTableDimensionsData(responseParsed.data);
                }
                
                if(req.request.status != 0) {

                    obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#topArticles-results"), true);
                }
            });

        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onGetPingDiffIndicators(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updatePingDiffIndicatorsData(responseParsed);
                obj.liveDashboard_template.updatePingDiffIndicatorsChartGraphData();

                if(req.request.status != 0) {

                    obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#widgetLoading_pingGraph-graph"), true);
                }
            });

        }
    }

        /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onGetPingLoadTimeIndicators(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updatePingLoadTimeIndicatorsData(responseParsed);
                obj.liveDashboard_template.updatePingAvgLoadIndicatorsChartGraphData();

                if(req.request.status != 0) {

                    obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#widgetLoading_pingLoadTime-graph"), true);
                }
            });
        }
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onIndicatorsByDateDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateIndicatorsData(responseParsed);
                obj.liveDashboard_template.updateIndicatorsGraphData();

                if(req.request.status != 0) {
                    
                    obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);
                }
            });

        }
    }

    protected updatePagination(totalCount) {

        this.liveDashboard_template.updatePagination(totalCount);
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = this.liveDashboard_template.getViewModelForRequest();
        subViewModel['filters']['keyword'] = keyword;
        subViewModel['filters']['filterId'] = id;

        let usrReq_url = '/api/live_dashboard/autoCompleteSuggestions/get/';

        let usrReq_callback;
        usrReq_callback = this.onGetMultipleAutoCompleteSuggestionsReturn.bind(this, id);

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSuggestionsReturn(filterId, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    (obj.liveDashboard_template.setDynamicAutoCompleteMultiSelectFilterItems(filterId, responseParsed.data));
                }
            });
        };

    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onSegmentsByDateDataRequestReturn(req, obj): Function{

        return function(){

            // obj.manageResponse(req, obj, function(){

            //     let responseParsed = JSON.parse(req.request.response);

            //     obj.updateSegmentsData(responseParsed);
            // });

            // if(req.request.readyState == 4){
            //     if (req.request.status == 200) {
            //         // LOADING : ends
            //         obj.loadingOut(obj.liveDashboard_template.builtTemplate.querySelector("#segmentsByDate-results"));
            //     }
            // }
        }
    }

    protected setAutoRefresh(){

        let self = this;

        // Check if a global interval exists and clear it if necessary
        if (window['liveDashBoardRefreshInterval']) {

            clearInterval(window['liveDashBoardRefreshInterval']);
        }

        // Set a new interval and store it in the global window object
        window['liveDashBoardRefreshInterval'] = setInterval(function() {

            if(self.urlPath==window.location.origin + window.location.pathname){

                self.autoRefresh();
            } else {

                clearInterval(window['liveDashBoardRefreshInterval']);
            }
        }, 300000);
    }

    protected updateReportStatusData(responseParsed: any): void{

        this.liveDashboard_template.setReportStatusData(responseParsed.reportStatusData);
    }

    protected updateSampledDatesData(responseParsed: any): void{

        this.liveDashboard_template.setSampledDatesData(responseParsed.sampledDatesData);
    }

    protected updatePingDiffIndicatorsData(responseParsed: any): void{

        this.liveDashboard_template.setPingDiffIndicatorsData(responseParsed.indicatorsData);
    }

    protected updatePingLoadTimeIndicatorsData(responseParsed: any): void{

        this.liveDashboard_template.setPingLoadTimeIndicatorsData(responseParsed.indicatorsData);
    }

    protected updateIndicatorsData(responseParsed: any): void{

        this.liveDashboard_template.setIndicatorsData(responseParsed.indicatorsData);
        this.liveDashboard_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData, 0);
        // axis 5 is the comp series
        this.liveDashboard_template.setTimelineAnnotationsData(responseParsed.compTimelineAnnotationsData, 5);

    }

    protected updateTotalsData(responseParsed: any): void{

        this.liveDashboard_template.setTotalsData(responseParsed.totalsData);
    }

    protected updateTableDimensionsData(data: any): void{

        this.liveDashboard_template.setTableDimensionsData(data);
    }

    protected updateTopArticlesData(responseParsed: any): void{

        this.liveDashboard_template.setTopArticlesData(responseParsed.data);
    }

    protected updateIndicatorsBreakdownData(responseParsed: any): void {

        this.liveDashboard_template.setIndicatorsBreakdownData(responseParsed.indicatorsBreakdownData);
    }

    protected updateSegmentsData(responseParsed: any): void {

        this.liveDashboard_template.setSegmentsData(responseParsed.segmentsTableData);
    }

    protected setBotMode() {

        this.liveDashboard_template.setBotMode();
    }

    public getReportData(): void {

        this.setAutoRefresh();
        this.getReportWidgetsData();
        this.getReportStatus();
        this.getTotalsData();
        this.getTableData(true);
        this.getIndicatorsByDateData();
    }

    public loadSnapshot(dateTime) {

        this.setAutoRefresh();
        this.getTotalsData();
        this.getReportWidgetsData();
        this.getTableData();
    }

    /**
     * Hook.
     *
     * Initiates data refresh.
     */
    protected filterSingleGroupSelectorOnChange(element){

        if(element=='brandFilter' || element=='intervalFilter'){

            this.getReportData();
        }

        if (element=='metricFilter') {

            this.getTableData();

            this.liveDashboard_template.updateVisitsViewsToggle();
            this.liveDashboard_template.updateIndicatorsGraphData();
            this.liveDashboard_template.updateBreakdownDonutCharts();
        }

        if (element=='comparisonFilter') {

            this.liveDashboard_template.updateComparisonSwitch();
            this.getReportData();
        }

        if (element=='deltaFilter') {

            this.liveDashboard_template.updateDeltaMode();
            this.getTableData(true);
        }

    }

    protected filterMultipleSelectorOnChange(){

        this.setBotMode();
        this.getReportData();
    }

    protected autoRefresh() {

        this.getReportData();
    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
            this.setAutoRefresh();
        }
    }

    protected filterSimpleOnChange(){

        this.getReportData();
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/liveDashboard.ts